import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'

// Plugins
import AppStorage from './plugins/storage'
Vue.use(AppStorage)

import ApiResponse from './plugins/api-response'
Vue.use(ApiResponse)

import UserPermissions from './plugins/user'
Vue.use(UserPermissions)

import VueToastr from "vue-toastr";
Vue.use(VueToastr, {
  defaultStyle: { "background-color": "#28a745" },
  defaultProgressBar: false
});

// Components
import Alert from './components/Alert'
Vue.component('alert', Alert)

import Password from './components/Password'
Vue.component('password', Password)

import Loading from './components/Loading'
Vue.component('loading', Loading)

import Modal from './components/Modal'
Vue.component('modal', Modal)

import DatePicker from 'vue2-datepicker';
Vue.component('date-picker', DatePicker)

import Pagination from 'vue-pagination-2';
Vue.component('pagination', Pagination);

import AreYouSure from './components/AreYouSure'
Vue.component('are-you-sure', AreYouSure)

import PaymentSchedule from './components/PaymentSchedule'
Vue.component('payment-schedule', PaymentSchedule)

import vSelect from 'vue-select'
Vue.component('v-select', vSelect)

import './theme'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

